import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=1e2dac12&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=1e2dac12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2dac12",
  null
  
)

export default component.exports